import { Component, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CASO } from '../../interfaces/caso.interface';
import { CasoService } from '../../services/caso.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-caso',
  templateUrl: './caso.component.html',
  styleUrls: ['./caso.component.css']
})
export class CasoComponent implements OnInit {

  currentCaso = 0
  datepipe: DatePipe = new DatePipe('es-ES')

  urlVideoSafe: any;

  imgMain: any;

  caso: CASO = {};

  id_next: number = 0
  id_prev: number = 0

  fecha: string | null = ''

  constructor(
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private router: Router,
    private titleService: Title,
    private casoService: CasoService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page
    this.route.params.subscribe(params => {
      this.currentCaso = params['id']
    });
  }

  ngOnInit(): void {

    this.casoService.getCaso(this.currentCaso).subscribe(
      (resp) => {
        this.caso = resp

        this.fecha = this.caso.date ? this.caso.date : ''
        this.fecha = this.datepipe.transform(this.fecha, 'dd MMMM yyyy')
        this.imgMain = 'https://' + this.caso.imgUrl

        if (resp.next) {
          if (resp.next.id != null &&
            // resp.id !== 19
            (!resp.next.datePublishing || resp.next.datePublishing === "" || new Date(resp.next.datePublishing) < new Date())
          ) {
            this.id_next = resp.next.id
          }
        }
        if (resp.prev) {
          if (resp.prev.id != null
          ) { this.id_prev = resp.prev.id }
        }


        this.titleService.setTitle('retailCo Retalk: ' + this.caso.title);
      },
      (err) => { }
    )
  }

}
